function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_107",
  "data-name": "Group 107",
  transform: "translate(-1250.5 -121)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_681",
  "data-name": "Path 681",
  d: "M1264.5,134.03l-.94.97-4.59-4.63a4.9,4.9,0,0,1-3.25,1.19,5,5,0,0,1-2.63-.72,5.431,5.431,0,0,1-1.89-1.92,5.329,5.329,0,0,1,0-5.28,5.431,5.431,0,0,1,1.89-1.92,5.091,5.091,0,0,1,5.22,0,5.431,5.431,0,0,1,1.89,1.92,5.3,5.3,0,0,1-.3,5.73Zm-8.78-3.69h-.03a3.858,3.858,0,0,0,2.02-.55,4.169,4.169,0,0,0,1.47-1.48,4.017,4.017,0,0,0,.55-2.03,3.893,3.893,0,0,0-.55-2.03,3.941,3.941,0,0,0-1.47-1.48,3.882,3.882,0,0,0-2-.55,3.789,3.789,0,0,0-2,.55,4.169,4.169,0,0,0-1.47,1.48,4.017,4.017,0,0,0-.55,2.03,3.893,3.893,0,0,0,.55,2.03,3.941,3.941,0,0,0,1.47,1.48A3.8,3.8,0,0,0,1255.72,130.34Z"
}));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.8b1acfb4.svg";
export { ForwardRef as ReactComponent };